var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,20V10h8V20h3V12h3L12,3,2,12H5v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.25,10h10V20h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.17,14.54c-.95-.24-1.25-.5-1.25-.89s.42-.77,1.12-.77,1,.35,1,.87H14a1.64,1.64,0,0,0-1.33-1.59v-.91H11.42v.9A1.63,1.63,0,0,0,10,13.65c0,1,.79,1.45,2,1.73s1.25.61,1.25,1-.21.75-1.13.75-1.19-.39-1.24-.88H9.88a1.76,1.76,0,0,0,1.54,1.6v.9h1.25v-.9c.81-.15,1.46-.62,1.46-1.47C14.13,15.19,13.11,14.79,12.17,14.54Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseMoney);
export default __webpack_public_path__ + "static/media/house-money.ccd744ee3e0f0d20649287ebde067cd8.svg";
export { ForwardRef as ReactComponent };